var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"col-lg-6 offset-lg-3 col-sm-12"},[_c('div',[_c('p',[_vm._v("Your Delete Request has been sent. Please give us 45 days for your request to be completed.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }